import { render, staticRenderFns } from "./Capabilities.vue?vue&type=template&id=b802e936&scoped=true"
import script from "./Capabilities.vue?vue&type=script&lang=js"
export * from "./Capabilities.vue?vue&type=script&lang=js"
import style0 from "./Capabilities.vue?vue&type=style&index=0&id=b802e936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b802e936",
  null
  
)

export default component.exports